 
import {
  Grid,
} from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import {
  ControlledCustomSelect,
  CustomFormLabel,
} from "../../../../../../components/formsComponents";
import { useDispatchWrapper, useFetchPolicies } from "../../../../../../hooks";
import { IAutomobileQuickAplication } from "../../../../../../redux/automobileApplication/automobileApplication.types";
import { useNavigate } from "react-router-dom";
import { addAutomobileQuickApllication } from "../../../../../../redux/automobileApplication/automobileApplicationActions";
import { Dialog } from "../../../../../../components/Dialogs/Dialog";
import { useAutomobilePolicyDriverInfo } from "../hooks/useAutomobilePolicyDriverInfo";
import { useAutomobilePolicyVehcileInfo } from "../hooks/useAutomobileVehicleInfo";

export interface IAutomobileQuickApplicationProps {
  open: boolean;
  customerPolicyId: number;
  customerId: number;
  type: string;
  data: IAutomobileQuickAplication;
  onComplete: () => void;
  onClose: () => void;
}
export const QuickApplicationDialog: React.FC<
  IAutomobileQuickApplicationProps
> = (props) => {
  const { open, data, customerPolicyId, customerId,type,  onClose, onComplete } =
    props;
  const { policies } = useFetchPolicies();
  const dispatch = useDispatchWrapper();
  const [loading, setLoading] = React.useState(false);

  const { driverDropDown } = useAutomobilePolicyDriverInfo(customerPolicyId);
  const { vehcileDropdown } = useAutomobilePolicyVehcileInfo(customerPolicyId);

  const navigate = useNavigate();
  const {
    values,
    handleChange,
    handleSubmit,
    setValues,
    setFieldValue,
    errors,
  } = useFormik({
    initialValues: data,
    validate: (values) => {},
    onSubmit: async (values) => {
      console.log("values", values);
      if (customerId && customerPolicyId) {
        setLoading(true);
        dispatch(
          addAutomobileQuickApllication(
            {
              ...values,
              customer_policy_id: customerPolicyId,
              customer_id: customerId,
              type: type,
            },
            (isSuccess) => {
              if (isSuccess) {
                onComplete();
              }
              setLoading(false);
            }
          )
        );
      }
    },
  });

  return (
    <>
      <Dialog
        open={open}
        title="Create Quick Application"
        onClose={onClose}
        size={"md"}
        contentWrappedWithForm={{ onSubmit: handleSubmit }}
        actions={[
          {
            type: "submit",
            label: "Save & Close",
            variant: "contained",
            disabled: loading,
          },
        ]}
      >
        <form onSubmit={handleSubmit}>
          <Grid container spacing={1}>
            <Grid item xs={12} lg={6}>
              <CustomFormLabel>Select Drivers</CustomFormLabel>
              <ControlledCustomSelect
                variant="outlined"
                size="small"
                type="number"
                name="driver_incremental_number"
                value={values.driver_incremental_number || []}
                onChange={(e) => {
                  setFieldValue("driver_incremental_number", e.target.value);
                }}
                displayEmpty
                multiple
                fullWidth
                placeholder="Select one"
                options={driverDropDown}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <CustomFormLabel>Select Vehicles</CustomFormLabel>
              <ControlledCustomSelect
                variant="outlined"
                size="small"
                type="number"
                name="vehicle_incremental_number.vehicle_one"
                value={values.vehicle_incremental_number || []}
                onChange={(e) => {
                  setFieldValue("vehicle_incremental_number", e.target.value);
                }}
                displayEmpty
                multiple
                fullWidth
                placeholder="Select one"
                options={vehcileDropdown}
              />
            </Grid>
          </Grid>
        </form>
      </Dialog>
    </>
  );
};

{
  /* {[0, 1, 2, 3].map((index) => {
              // Get all selected values except current index AND skip empty strings
              const selectedDrivers = values.driver_incremental_number.filter(
                (val, i) => i !== index && val !== ""
              );

              const filteredOptions = driverDropDown.filter(
                (option: { label: string; value: string }) =>
                  !selectedDrivers.includes(option.value)
              );

              // Get the current selected value (must match option object)
              const selectedValue =
                driverDropDown.find(
                  (option) =>
                    option.value === values.driver_incremental_number[index]
                ) || null;

              return (
                <Grid item xs={12} lg={3} key={`driver-${index}`}>
                  <CustomFormLabel>{`Driver ${index + 1}`}</CustomFormLabel>
                  <Autocomplete
                    value={selectedValue}
                    options={filteredOptions}
                    getOptionLabel={(option) => option.label}
                    onChange={(_, newValue) => {
                      const updated = [...values.driver_incremental_number];
                      updated[index] = newValue ? newValue.value : ""; // "" if cleared
                      setFieldValue("driver_incremental_number", updated);
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                    renderInput={(params) => (
                      <CustomTextField {...params}  />
                    )}
                    clearOnEscape
                    disableClearable={false}
                  />
                </Grid>
              );
            })} */
}
